import { Image } from 'react-native-web';

// we can just use the react native web image component here because it supports SVG out of the box
export default Image;
